import * as React from 'react'
import { DisplayContent } from 'react-content-engine'
import { connect } from 'react-redux'

import { ListItem } from 'components/List'
import { AppState } from '../../../data/state'

interface BedAndBreakfastProps {
  bedAndBreakfast: boolean
}

const BedAndBreakfast: React.FC<BedAndBreakfastProps> = ({
  bedAndBreakfast,
}) => {
  return bedAndBreakfast ? (
    <ListItem>
      <DisplayContent addNode contentKey="bed-and-breakfast-summary">
        Bed And Breakfast
      </DisplayContent>
    </ListItem>
  ) : null
}

export default connect((state: AppState) => ({
  bedAndBreakfast: state.funnelOrder.bedAndBreakfast,
}))(BedAndBreakfast)
